<template>
  <el-config-provider :locale="zhCn">
    <router-view />
    <AIAssistant v-if="authStore.isAuthenticated" />
  </el-config-provider>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { useAuthStore } from '@/stores/useAuthStore';
import AIAssistant from '@/components/AIAssistant.vue';
import { ensureUploadLimits } from '@/api/uploadLimitsApi';
import { useFeatureModulesStore } from '@/stores/useFeatureModulesStore';

const authStore = useAuthStore();
const featureModulesStore = useFeatureModulesStore();

onMounted(() => {
  void featureModulesStore.fetchFeatures();
});

watch(
  () => authStore.isAuthenticated,
  (ok) => {
    if (ok) {
      void ensureUploadLimits();
      void featureModulesStore.fetchFeatures(true);
    }
  },
  { immediate: true },
);
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
</style>

